"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tfs_css_variables_1 = __importDefault(require("tfs.css-variables"));
var shadow = '4px';
var hoverShadow = '2px';
exports.default = {
    button: {
        padding: '0.5rem 1.7rem',
        borderRadius: '1.25rem',
        backgroundColor: tfs_css_variables_1.default.colorRuby,
        color: tfs_css_variables_1.default.colorRubyTypography,
        boxShadow: "0 " + shadow + " 0 0 " + tfs_css_variables_1.default.colorRubyShadow,
        border: 'none',
        cursor: 'pointer',
        fontSize: '1rem',
        fontWeight: 'bold',
        transitionProperty: 'background-color, box-shadow, transform',
        transitionDuration: tfs_css_variables_1.default.paceFast,
        transitionTimingFunction: tfs_css_variables_1.default.easeIn,
        whiteSpace: 'nowrap',
        outline: 'none',
        '&:hover, &:focus': {
            backgroundColor: tfs_css_variables_1.default.colorRubyHover,
            boxShadow: "0 " + hoverShadow + " 0 0 " + tfs_css_variables_1.default.colorRubyShadow,
            transform: "translateY(" + hoverShadow + ")",
            transitionTimingFunction: tfs_css_variables_1.default.easeOut,
        },
        '&:active': {
            transform: "translateY(" + shadow + ")",
            boxShadow: '0 0 0 0 transparent !important',
        },
    },
    colorGreen: {
        backgroundColor: tfs_css_variables_1.default.colorGreen,
        color: tfs_css_variables_1.default.colorGreenTypography,
        boxShadow: "0 " + shadow + " 0 0 " + tfs_css_variables_1.default.colorGreenShadow,
        '&:hover, &:focus': {
            backgroundColor: tfs_css_variables_1.default.colorGreenHover,
            boxShadow: "0 " + hoverShadow + " 0 0 " + tfs_css_variables_1.default.colorGreenShadow,
        },
    },
    colorBlue: {
        backgroundColor: tfs_css_variables_1.default.colorBlue,
        color: tfs_css_variables_1.default.colorBlueTypography,
        boxShadow: "0 " + shadow + " 0 0 " + tfs_css_variables_1.default.colorBlueShadow,
        '&:hover, &:focus': {
            backgroundColor: tfs_css_variables_1.default.colorBlueHover,
            boxShadow: "0 " + hoverShadow + " 0 0 " + tfs_css_variables_1.default.colorBlueShadow,
        },
    },
    colorWhite: {
        backgroundColor: tfs_css_variables_1.default.colorWhite,
        borderColor: tfs_css_variables_1.default.colorWhiteBorder,
        color: tfs_css_variables_1.default.colorGrayA,
        boxShadow: "0 " + shadow + " 0 0 " + tfs_css_variables_1.default.colorWhiteShadow,
        borderRadius: '0.5rem',
        border: "1px solid " + tfs_css_variables_1.default.colorWhiteBorder,
        '&:hover, &:focus': {
            backgroundColor: tfs_css_variables_1.default.colorWhiteHover,
            boxShadow: "0 " + hoverShadow + " 0 0 " + tfs_css_variables_1.default.colorWhiteShadow,
        },
    },
    disabled: {
        backgroundColor: tfs_css_variables_1.default.colorGrayE,
        color: tfs_css_variables_1.default.colorGrayC,
        boxShadow: 'none',
        '&:hover, &:active, &:focus': {
            backgroundColor: tfs_css_variables_1.default.colorGrayE,
            cursor: 'default',
            boxShadow: '0 0 0 0 transparent',
            transform: 'translateY(0)',
        },
    },
    colorTransparent: {
        backgroundColor: 'transparent',
        borderRadius: 0,
        border: 'none',
        padding: 0,
        color: tfs_css_variables_1.default.colorGrayA,
        boxShadow: 'none',
        fontWeight: 'normal',
        '&:hover, &:active, &:focus': {
            backgroundColor: 'transparent',
            boxShadow: '0 0 0 0 transparent',
            transform: 'translateY(0)',
        },
    },
    children: {
        display: 'inline-block',
    },
    icon: {
        textShadow: '0 0.125rem 0.125rem rgba(0,0,0,0.2)',
        marginRight: '0.7rem',
    },
    iconRight: {
        marginRight: 0,
        marginLeft: '0.7rem',
        float: 'right',
    },
};
//# sourceMappingURL=Button.styles.js.map